<style>
  hr {
    border-top: 1px solid #0003;
    width: 100%;
    margin: 2px 0;
  }
</style>


<hr />
